import React from 'react';
import * as mobx from 'mobx';
import { observer } from 'mobx-react';
import { OrderBookingEventBlueprintsFormVM } from './order-booking-event-blueprint-form.viewmodel';
import { FORM_CONFIG, OrderBookingEventBlueprintFieldKey } from './order-booking-event-blueprint.config';
import { CommonPopupBodyFooterLayout } from '../../../global/common-popup/common-popup-body-footer-layout';
import { FormFieldInput } from '../../../global/form/form-field-input/form-field-input';
import { DefaultCloseSubWindowButton } from '../../../global/sub-window/common/common-close-sub-window-buttons';
import { ADD_TEXT, CANCEL_TEXT, LOADING } from '../../../../constants/common-labels.constants';
import { participantLinkOptions } from '../../../_blueprints/event-blueprints/event-blueprint-form/event-blueprint-form.presentration';
import { RichTextEditor } from '../../../global/rich-text-editor';
import { FormField } from '../../../global/form/form-field/form-field';
import { FormattedMessage } from 'react-intl';
import { ViewBlueprintDetailsSection } from '../../../_events/_manage-event/shared/view-blueprint-details-section/view-blueprint-details-section';
import { EventAttributesMultiselect } from '../../../_blueprints/event-blueprints/event-blueprint-form/event-attributes-multiselect/event-attributes-multiselect.container';

type OrderBookingEventBlueprintFormPresentationProps = {
    vm: OrderBookingEventBlueprintsFormVM;
};

export const OrderBookingEventBlueprintFormPresentation = observer((props: OrderBookingEventBlueprintFormPresentationProps) => {
    const { vm } = props;
    const {
        publicName,
        publicDescription,
        participantLinkType
    } = vm.getFormFields(OrderBookingEventBlueprintFieldKey);

    return (
        <CommonPopupBodyFooterLayout
            body={
                <form className='oe-form connection-group-form'>
                    {vm.isLoading ? (
                        <FormattedMessage
                            {...LOADING}
                            values={{
                                suffix: '...',
                            }}
                        />
                    ) : (
                        <div className='oe-form__body'>
                            <FormField
                                label={<FormattedMessage {...FORM_CONFIG[OrderBookingEventBlueprintFieldKey.NAME].labelDescriptor} />}
                            >
                                <ViewBlueprintDetailsSection
                                    blueprintDetails={vm.getSelectedBlueprintTemplateDetails()}
                                    blueprintItemType={vm.blueprint.type}
                                />
                            </FormField>
                            <FormFieldInput.Text
                                field={publicName}
                                labelDescriptor={FORM_CONFIG[OrderBookingEventBlueprintFieldKey.PUBLIC_NAME].labelDescriptor}
                                withError
                            />
                            <FormField label={<FormattedMessage {...FORM_CONFIG[OrderBookingEventBlueprintFieldKey.PUBLIC_DESCRIPTION].labelDescriptor} />}>
                                <RichTextEditor
                                    className='m-top-0px'
                                    value={publicDescription.value as string}
                                    onChange={mobx.action((event, editor) => {
                                        publicDescription.setValue(editor.getData());
                                    })}
                                    onBlur={publicDescription.setTouched}
                                    validationError={
                                        !publicDescription.valid && publicDescription.touched &&
                                        <FormattedMessage
                                            values={
                                                { fieldName: vm.intl.formatMessage(
                                                    FORM_CONFIG[OrderBookingEventBlueprintFieldKey.PUBLIC_DESCRIPTION].labelDescriptor
                                                )}
                                            }
                                            {...publicDescription.validationMessage}
                                        />
                                    }
                                />
                            </FormField>
                            <FormFieldInput.Select
                                field={participantLinkType}
                                labelDescriptor={FORM_CONFIG[OrderBookingEventBlueprintFieldKey.PARTICIPANT_LINK_TYPE].labelDescriptor}
                                customOptions={
                                    participantLinkOptions().map(({ value, label }, i) => {
                                        return <option value={value} key={`${i}_${value}`}>{label}</option>;
                                    })
                                }
                                withError
                            />
                            <EventAttributesMultiselect
                                selectedEventAttributes={vm.getSelectedEventAttributes()}
                                availableEventAttributes={vm.getAvailableEventAttributes()}
                                setEventAttributes={vm.setEventAttributes}
                                removeEventAttribute={vm.removeEventAttribute}
                            />
                        </div>
                    )}
                </form>
            }
            footer={
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultCloseSubWindowButton
                        text={vm.intl.formatMessage(ADD_TEXT)}
                        modifier={['fat', 'confirm-safe']}
                        onClick={vm.submitForm}
                        disabled={vm.isLoading || vm.isSaving}
                    />
                    <DefaultCloseSubWindowButton
                        text={vm.intl.formatMessage(CANCEL_TEXT)}
                    />
                </div>
            }
        />
    );
});